// Literal brand color for canvas consumers (chart.js, Maps, color-interpolating
// libs) that cannot resolve CSS var(). Reads the injected variable's current
// value; falls back to the built-in hex.
export const brandColor = (name, fallback) =>
  (typeof window !== 'undefined' &&
    getComputedStyle(document.documentElement).getPropertyValue(`--brand-${name}`).trim()) ||
  fallback;
